var map = {
	"./action-nav.en.json": 138,
	"./articles-list.en.json": 140,
	"./articles/en/biodiversity.en.json": 142,
	"./articles/en/economic-mistakes.en.json": 143,
	"./articles/en/law.en.json": 144,
	"./articles/en/negative-economics.en.json": 145,
	"./articles/en/protected-areas.en.json": 146,
	"./articles/en/public-opinion.en.json": 147,
	"./articles/en/similar-stories.en.json": 148,
	"./articles/en/xrays.en.json": 149,
	"./film.en.json": 160,
	"./footer.en.json": 162,
	"./hero-unit.en.json": 164,
	"./media-publications.en.json": 166,
	"./pages/en/about.en.json": 168,
	"./pages/en/e40.en.json": 169,
	"./pages/en/expertise.en.json": 170,
	"./pages/en/petition.en.json": 171,
	"./pages/en/position.en.json": 172,
	"./pages/en/press-kit.en.json": 173,
	"./problem-description.en.json": 180,
	"./social-feeds.en.json": 182,
	"./timeline.en.json": 184,
	"./top-nav.en.json": 186
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;


//////////////////
// WEBPACK FOOTER
// ./src/assets/content ^\.\/.*\.en\.json$
// module id = 136
// module chunks = 0